import React, { useContext } from 'react';
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from 'recharts';
import {
  ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from '../../common/shadcn/chart';
import { CompanyContext } from '../../../context/CompanyContext';
import { ChartIcon } from '../../../VentoryUI/icons/Chart/ChartIcon';
import { LoadingSpinner } from '../../pages/Common/LoadingSpinner';

interface ChartBarStackedProps {
  config: ChartConfig;
  data: any[];

  xAxis: string;
  title: string;

  loading: boolean;

  legend?: boolean;

  hideLabel?: boolean;
  hideIndicator?: boolean;

  footerBuilder?: () => React.ReactNode;
  tickFormatter?: (value: any) => string;
}

export function ChartBarStacked({
  config,
  data,
  xAxis,
  title,
  loading,
  legend = false,
  hideLabel = false,
  hideIndicator = false,
  footerBuilder = () => null,
  tickFormatter = value => value.slice(0, 6),
}: ChartBarStackedProps) {
  const { currentCompany } = useContext(CompanyContext);

  const footer = footerBuilder();
  const dataKeys = Object.keys(config);

  return (
    <div className='flex w-full flex-col rounded-4 border border-gray-100'>
      <div className='flex h-12 items-center border-b px-2'>
        <ChartIcon className='px-3' color={currentCompany.settings.primaryColor} />
        <p className='font-semibold text-title'>{title}</p>
      </div>
      <div className='flex h-full items-center py-8'>
        <ChartContainer className='h-[420px] w-full' config={config}>
          {!loading ? (
            <BarChart accessibilityLayer={false} data={data}>
              <CartesianGrid vertical={false} stroke='#f3f4f6' strokeWidth={2} />
              <XAxis dataKey={xAxis} tickLine={true} tickMargin={10} axisLine={false} tickFormatter={tickFormatter} />
              <YAxis tickLine={false} axisLine={false} />
              <ChartTooltip
                cursor={{ fill: 'rgb(0 0 0 / 0.05)' }}
                content={
                  <ChartTooltipContent
                    hideLabel={hideLabel}
                    hideIndicator={hideIndicator}
                    className='rounded-1 border-none bg-black/90 font-semibold text-gray-400'
                  />
                }
              />
              {legend ? <ChartLegend content={<ChartLegendContent />} /> : null}
              {dataKeys.map((key, index) => (
                <Bar
                  dataKey={key}
                  stackId='a'
                  style={{ fill: config[key as any].color }}
                  radius={index === dataKeys.length - 1 ? [6, 6, 0, 0] : [0, 0, 0, 0]}
                />
              ))}
            </BarChart>
          ) : (
            <div className='flex h-full items-center justify-center'>
              <LoadingSpinner color={currentCompany.settings.primaryColor} />
            </div>
          )}
        </ChartContainer>
      </div>
    </div>
  );
}
